import {Button, Modal} from "react-bootstrap";
import * as React from "react";
import {FormattedMessage} from "react-intl";


export enum ModalMessageDialogMode {
    SUCCESS="SUCCESS",
    ERROR="ERROR"
}
interface Props {
    mode: ModalMessageDialogMode,
    onClose: ()=>void;
    title?: string;
    body: string;
}

export const ModalMessageDialog: React.FC<Props> = (props: Props) => {
    let defaultMessage =
        <FormattedMessage id="studio.settings.modal-message.defaut-message.success"
                                                               defaultMessage="Success"
        />
    switch (props.mode) {
        case ModalMessageDialogMode.ERROR:
            defaultMessage=
                <FormattedMessage id="studio.settings.modal-message.defaut-message.error"
                                  defaultMessage="Error"
                />
            break;
    }
    return (
        <Modal show={true} onHide={props.onClose}>
            <Modal.Header closeButton>
                <Modal.Title>{props.title? props.title : defaultMessage}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {props.body}
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle="primary" onClick={props.onClose}>
                    <FormattedMessage id="studio.settings.modal-message.close"
                                      defaultMessage="Close"
                    />
                </Button>
            </Modal.Footer>
        </Modal>)
}
